import React from "react";
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Unstable_Grid2";
import { WorkShiftPlanningFilters } from "./WorkShiftPlanningFilters";
import { WorkShiftPlanningActions } from "./WorkShiftPlanningActions";
import { EmployeeListItemDto } from "../../models/employee/employee";

interface WorkShiftPlanningTopBarProps {
    employees: EmployeeListItemDto[];
    visibleEmployees: EmployeeListItemDto[];
}

export const WorkShiftPlanningTopBar = ({
    employees,
    visibleEmployees,
}: WorkShiftPlanningTopBarProps) => {
    return (
        <Box>
            <Grid2 container alignItems="center" spacing={2}>
                <WorkShiftPlanningFilters employees={employees} />
                <Grid2 container justifyContent="end" xs={true}>
                    <WorkShiftPlanningActions employees={visibleEmployees} />
                </Grid2>
            </Grid2>
        </Box>
    );
};
